<template xmlns="http://www.w3.org/1999/html">
  <div class="rlzy">
    <jzcgheader></jzcgheader>
    <div class="content">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="mbx">
        <el-breadcrumb-item  :to="{ path: '/jicailist' }">集中采购</el-breadcrumb-item>
        <el-breadcrumb-item >报名集采</el-breadcrumb-item>
      </el-breadcrumb>
      <div >
       <div> 
        <p style="background-color: white;font-size:24px;line-height: 35px;color:#333333;padding:19px 47px 19px 47px;">{{baseInfo.title}}</p>
       </div>
        <div> 
        </div>
        <div class="items liebiao">
          <div> 
            <p style="font-size:20px;line-height: 29px;color:#333333;background-color: white;padding:22px 47px 0 47px;">集采产品</p>
          </div>
          <el-form ref="form" style="width:1200px;margin: 0 auto" :model="form" label-width="100px" :rules="rules">
            <div style="margin-bottom:20px;background-color: white;padding:20px 47px 49px 47px;"> 
              <el-row :gutter="20"> 
                <el-col :span="12" v-for="(item,index) in form.products" :key="item.id"> 
                  <div style="background-color: #F5F6F9 ;padding:20px 20px;margin-bottom:20px;"> 
                    <p><span style="display: inline-block;width:100px;text-align: right;">产品名称：</span><span class="info" style="margin-left:10px;">{{item.name}}</span><el-button v-if="index>=chanpinNum && false" type="danger" size="mini" @click="btnRmProduct(index)" style="float:right;">删除</el-button></p>
                    <p style="margin-top:15px;"> <span ></span>  <el-form-item  label="采购数量："  :prop="'products.' + index + '.planQty'" :rules="rules.planQty">
            <el-input style="width:280px;" v-model="item.planQty" placeholder="请输入数量（默认0）"></el-input>
          </el-form-item></p>
                    <p style="margin-top:15px;">  <span ></span> <el-form-item label="备注(选填)："  prop="remark">
            <el-input style="width:280px;" v-model="item.remark" placeholder="请输入备注内容"></el-input>
          </el-form-item></p>
                  </div>
                </el-col>
              </el-row>
              <div> 
                <el-button v-if="false" style="float:right;" type="primary" size="mini" @click="btnAddProduct" >+产品</el-button>
              </div>
            </div>
            <div style="margin-bottom:20px;background-color: white;padding:14px 47px 20px 47px;"> 
              <p class="baseinfo">报名企业：<span style="font-weight: 500;">{{userInfo==undefined?'':userInfo.detail.tenantName}}</span></p>
              <p class="baseinfo2">
                <el-form-item label="联系人"  prop="contactPerson">
            <el-input style="width:280px;" v-model="form.contactPerson" placeholder="请输入联系人"></el-input>
          </el-form-item>
          <el-form-item label="联系电话"  prop="contactPhone">
            <el-input style="width:280px;" v-model="form.contactPhone" placeholder="请输入联系电话"></el-input>
          </el-form-item>
              </p>
            </div>
            <el-form-item style="text-align: center;">
            <p>  <el-radio v-model="radioRead" label="2">我已阅读并同意<span style="color:orange;">《集采服务协议》</span></el-radio></p>
            <el-button type="primary" @click="onSubmit('form')" :disabled="canBaoming">提交报名</el-button>
          </el-form-item>
        </el-form>
        </div>
      </div>
    </div>
    <!-- <el-dialog title="申请" width="600px" append-to-body :visible.sync="dialogTableVisible">
      <avue-form :option="sqoption" v-model="userForm" @submit="submitSwitch"></avue-form>
    </el-dialog> -->
  </div>
</template>
<script>
import {humanpageindex} from "../../request/moudle/jzcg";
import {centerpurchaseproductlist,centerpurchasedetail,centerpurchaseenroll}  from "../../request/moudle/jizhongcaigou";
import jzcgheader from './jzcgheader'
import config from "../../utils/config";
export default {
  name: "lijibaoming",
  components:{
    jzcgheader
  },
  data(){
    return {
      canBaoming:false,
      baseInfo:{},
      id:this.$route.query.id,
      userInfo:  this.common.getSessionStorage('userInfo'),
      radioRead:false,//同意协议
      form:{
        
        products:[
  
      ]},//动态表单
      chanpinNum:1,//默认数量，从接口获取
      rules:{
        planQty: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        contactPerson: [
          { required: true, trigger: 'blur', message:'请填写联系人' }
        ],
        contactPhone: [
          { required: true, trigger: 'blur', message:'请填写联系电话'}
        ],
      },//校验规则
    }
  },
  created() {
    
    this.getPros();
    this.getInfo();
  },
  methods:{
    //获取基本信息
    getInfo(){
      centerpurchasedetail({id:this.id}).then(res=>{
        this.baseInfo=res.data;
        
      }).catch();
    },
    //获取产品列表
    getPros(){
      centerpurchaseproductlist({centerPurchaseId:this.id}).then(res=>{

        this.form.products=res.data.map(item=>{
          return {...item,...{planQty:null,remark:null}}
        });
      }).catch();
    },
    login(){
      this.$router.push({
        path:'/login'
      })
    },
    //提交按钮
    onSubmit(){
      if(!this.common.getSessionStorage('userInfo')){
        this.$msgbox.confirm('您还未登录, 是否去登录?', '提示', {
          confirmButtonText: '去登录',
          cancelButtonText: '继续浏览',
          type: 'warning'
        }).then(() => {
          window.location.replace(config.pchref)
        })
        return
      }
      // alert(JSON.stringify(this.form.products.length));
      this.$refs.form.validate((valid) => {
          if (valid) {
            if(!this.radioRead){
        this.$message.error('请同意集采服务协议');
        return;
      }
          //  this.$message.success(JSON.stringify(this.form.products))
            const ps=this.form.products.map(
              item=>{
                return {
                  centerPurchaseId:this.id,
                  productId:item.id,
                  productName:item.name,
                  purchaseQty:item.planQty,
                  remark:item.remark
                }
              }
            )
          //   this.form.products=ps;
          //   this.baseInfo.centerPurchaseId=this.id;
          //   this.baseInfo.id=null;//必须处理
          this.canBaoming=true;
           centerpurchaseenroll({
            centerPurchaseId:this.id,
            contactPerson:this.form.contactPerson,
            contactPhone:this.form.contactPhone,
            products:ps
           }).then(res=>{
            this.canBaoming=false;
            this.$message.success('报名成功');
            this.$router.push({
        path:'/xvqiuxq',
        query:{id:this.id}
      })
           }).catch(err=>{
            this.canBaoming=false;
           });
          } else {
            return false;
          }
        });
    },
    //增加产品
    btnAddProduct(){
      this.form.products.push({});
    },
    //删除产品
    btnRmProduct(index){
      this.form.products.splice(index, 1)
    },
  }
}
</script>
<style lang="scss" scoped>
/* 设置el-form-item标签内的label字体大小 */
/deep/ .el-form-item__label {
  font-size: 16px; /* 修改为你想要的字体大小 */
  color:#666666 ;
}
.sousuo{
  background-color: #1266F9 !important;
  color:white !important;
}
.liebiao{
  color:#666666;
  font-size:16px;
  .lanse{
    color:#1C66FF;
  }
  .info{
    color:#333333 ;
    font-weight: 600;
  }
  .baseinfo{
    color:#333333;
    font-size:20px;
    line-height:29px;
    font-weight:500;
  }
  .baseinfo2{
    color:#333333;
    font-size:16px;
    line-height:23px;
    font-weight:400;
    margin-top:20px;
  }
}
  .rlzy{
    background: #F5F5F5;
    
    .content{
      width: 1200px;
      margin: 0 auto;
      .mbx{
        margin: 25px 0;
      }
    }
  }
</style>